export default __webpack_public_path__ + "static/media/CEO-Of-Monke.ce8d8f75.png";